import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  const cardsWrappers = gsap.utils.toArray(".card-wrapper");
  const cards = gsap.utils.toArray(".card");
  const cardsContainer = document.querySelector(".cards-wrapper");
  const program = document.querySelector("#program");

  if (!cardsWrappers.length || !cardsContainer || !program) return;

  let resizeTimer;

  const getOffsetStep = () => {
    return window.innerWidth > 768 ? 80 : 80;
  };

  /*
   * Rezerwujemy miejsce w dokumencie na przypięte karty.
   *
   * Ponieważ pinSpacing:false wyłącza automatyczne dodawanie
   * przestrzeni przez ScrollTrigger, sami zwiększamy wysokość
   * kontenera o wysokość najdłuższej karty.
   */
  const updateCardsHeight = () => {
    // reset, żeby zawsze mierzyć rzeczywistą wysokość
    gsap.set(cardsContainer, {
      clearProps: "minHeight,height"
    });

    const containerRect = cardsContainer.getBoundingClientRect();

    const cardsHeight = cards.reduce((max, card) => {
      return Math.max(max, card.getBoundingClientRect().height);
    }, 0);

    /*
     * Oryginalna wysokość kontenera.
     *
     * Jeśli rodzic posiada padding-bottom (np. lg:pb-[25vh]),
     * nie ruszamy go — padding pozostaje poza wysokością samego
     * cards-wrapper.
     */
    const originalHeight = cardsContainer.scrollHeight;

    /*
     * Rezerwujemy dodatkową przestrzeń wynikającą z wysokości
     * karty, ale tylko jeśli karta jest wyższa niż kontener.
     */
    const extraHeight = Math.max(
      0,
      cardsHeight - containerRect.height
    );

    if (extraHeight > 0) {
      gsap.set(cardsContainer, {
        minHeight: originalHeight + extraHeight
      });
    }
  };

  const createTriggers = () => {
    ScrollTrigger.getAll().forEach((trigger) => {
      if (trigger.vars.id && trigger.vars.id.toString().startsWith("card-")) {
        trigger.kill();
      }
    });

    const offsetStep = getOffsetStep();

    cardsWrappers.forEach((wrapper, i) => {
      const card = cards[i];

      if (!card) return;

      gsap.to(card, {
        ease: "power2.out",
        rotate: 0,

        scrollTrigger: {
          trigger: wrapper,

          start: `top-=${48 + i * offsetStep} top`,

          /*
           * Koniec jest liczony względem całego #program,
           * więc padding-bottom sekcji nadal jest uwzględniany.
           */
          end: "bottom bottom",
          endTrigger: program,

          scrub: true,

          pin: wrapper,
          pinSpacing: false,

          invalidateOnRefresh: true,

          id: `card-${i}`
        }
      });
    });
  };

  /*
   * Najpierw przygotuj właściwą wysokość kontenera,
   * potem utwórz ScrollTrigger.
   */
  const refreshCards = () => {
    ScrollTrigger.getAll().forEach((trigger) => {
      if (trigger.vars.id?.toString().startsWith("card-")) {
        trigger.kill();
      }
    });

    updateCardsHeight();
    createTriggers();

    ScrollTrigger.refresh();
  };

  /*
   * Fonty mogą zmienić wysokość kart.
   */
  if (document.fonts?.ready) {
    document.fonts.ready.then(() => {
      requestAnimationFrame(refreshCards);
    });
  }

  /*
   * Pierwsze uruchomienie.
   */
  refreshCards();

  /*
   * Resize / zmiana breakpointu.
   *
   * Debounce jest istotny, bo podczas resize przeglądarka
   * potrafi wykonać kilkadziesiąt eventów.
   */
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {
      refreshCards();
    }, 150);
  });
});